<template>
  <div class="register-form">
    <div class="progress mt-3 mb-4" style="height: 4px">
      <div
        class="progress-bar"
        role="progressbar"
        :style="`width: ${currentStep === 1 ? '100' : '50'}%`"
        :aria-valuenow="currentStep === 1 ? '100' : '50'"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
    <ValidationObserver
      class="register-form__form form"
      ref="observer"
      v-slot="{}"
      tag="form"
      autocomplete="off"
      @submit.prevent="handleSubmit"
    >
      <fieldset v-if="currentStep === 0" class="form__item">
        <legend class="form__legend title title--s text-primary weight-bold">
          {{ steps[currentStep].label }}
        </legend>
        <div class="form__description text mt-1 mb-4">
          <p>{{ steps[currentStep].description }}</p>
        </div>
        <div class="form__fields">
          <ValidationProvider
            class="form-group"
            name="rut"
            vid="rut"
            rules="required|rut|max:12"
            v-slot="{ classes, errors }"
            tag="div"
            key="rut"
            persist
          >
            <div :class="['form-wrapper', classes]">
              <label :class="['form-label', classes]" for="rut">RUT *</label>
              <input
                type="text"
                :class="['form-control', classes]"
                id="rut"
                maxlength="12"
                v-model="schedule.user.rut"
                v-rut
              />
            </div>
            <span v-if="!errors.length" class="form-helper"
              >Ej.: 12.345.678-9</span
            >
            <span v-else class="form-helper form-helper--error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="nombres"
            vid="firstname"
            rules="required|max:190"
            v-slot="{ classes, errors }"
            tag="div"
            key="firstname"
            persist
          >
            <div :class="['form-wrapper', classes]">
              <label :class="['form-label', classes]" for="firstname"
                >Nombres *</label
              >
              <input
                type="text"
                :class="['form-control', classes]"
                id="firstname"
                v-model="schedule.user.firstname"
              />
            </div>
            <span class="form-helper form-helper--error">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="apellidos"
            vid="lastname"
            rules="required|max:190"
            v-slot="{ classes, errors }"
            tag="div"
            key="lastname"
            persist
          >
            <div :class="['form-wrapper', classes]">
              <label :class="['form-label', classes]" for="lastname"
                >Apellidos *</label
              >
              <input
                type="text"
                :class="['form-control', classes]"
                id="lastname"
                v-model="schedule.user.lastname"
              />
            </div>
            <span class="form-helper form-helper--error">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="teléfono"
            vid="phone"
            rules="required|min:9|max:9|numeric"
            v-slot="{ classes, errors }"
            tag="div"
            key="phone"
            persist
          >
            <div :class="['form-wrapper', classes]">
              <label :class="['form-label', classes]" for="phone"
                >Teléfono *</label
              >
              <div :class="['form-phone', classes]">
                <input
                  type="number"
                  :class="['form-control', classes]"
                  id="phone"
                  v-model="schedule.user.phone"
                  maxlength="9"
                />
              </div>
            </div>
            <span v-if="!errors.length" class="form-helper"
              >Ej.: 9XXXXXXXX</span
            >
            <span v-else class="form-helper form-helper--error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="mail"
            vid="email"
            rules="required|max:190|email"
            v-slot="{ classes, errors }"
            tag="div"
            key="email"
            persist
          >
            <div :class="['form-wrapper', classes]">
              <label :class="['form-label', classes]" for="email">Mail *</label>
              <input
                type="email"
                :class="['form-control', classes]"
                id="email"
                v-model="schedule.user.email"
              />
            </div>
            <span class="form-helper form-helper--error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div>
          <span class="form-helper mb-3">* Datos obligatorios</span>
        </div>
      </fieldset>
      <fieldset v-if="currentStep === 1" class="form__item">
        <legend class="form__legend title title--s text-primary weight-bold">
          {{ steps[currentStep].label }}
        </legend>
        <div class="form__description text mt-1 mb-4">
          <p>{{ steps[currentStep].description }}</p>
        </div>
        <div class="form__fields">
          <ValidationProvider
            v-if="
              current_brand &&
                current_brand.children &&
                current_brand.children.length > 1
            "
            class="form-group"
            name="marca"
            vid="brand"
            rules="required"
            v-slot="{ classes, errors }"
            tag="div"
            key="brand"
            persist
          >
            <div :class="['form-wrapper form-select', classes]">
              <label :class="['form-label', classes]" for="brand"
                >Marca *</label
              >
              <select
                :class="['form-control', classes]"
                id="brand"
                v-model="schedule.car.brand"
                @change="handleGetModelsByBrand"
              >
                <option disabled>Selecciona una marca</option>
                <option
                  v-for="brand in current_brand.children"
                  :value="brand"
                  :key="brand.id"
                  >{{ brand.name }}</option
                >
              </select>
            </div>
            <span class="form-helper form-helper--error">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="modelo"
            vid="model"
            rules="required"
            v-slot="{ classes, errors }"
            tag="div"
            key="model"
            persist
          >
            <div :class="['form-wrapper form-select', classes]">
              <label :class="['form-label', classes]" for="model"
                >Modelo *</label
              >
              <select
                :class="['form-control', classes]"
                id="model"
                v-model="schedule.car.model"
              >
                <option disabled>Selecciona un modelo</option>
                <option
                  v-for="model in models"
                  :value="model"
                  :key="model.id"
                  >{{ model.name }}</option
                >
              </select>
            </div>
            <span class="form-helper form-helper--error">{{ errors[0] }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="patente"
            vid="license"
            :rules="
              brandId === 'GA'
                ? 'validPatent|min:6|max:6|required'
                : 'validPatent|min:6|max:6'
            "
            v-slot="{ classes, errors }"
            tag="div"
            key="license"
            persist
          >
            <div :class="['form-wrapper', classes]">
              <label :class="['form-label', classes]" for="license">
                Patente <template v-if="brandId === 'GA'">*</template>
              </label>
              <input
                type="text"
                :class="['form-control', classes]"
                id="license"
                v-model="schedule.car.license"
                maxlength="6"
              />
            </div>
            <span v-if="!errors.length" class="form-helper">Ej.: AB12CD</span>
            <span v-else class="form-helper form-helper--error">{{
              errors[0]
            }}</span>
          </ValidationProvider>
          <ValidationProvider
            class="form-group"
            name="kilometraje"
            vid="mileage"
            rules
            v-slot="{ classes, errors }"
            tag="div"
            key="mileage"
            persist
          >
            <div :class="['form-wrapper form-select', classes]">
              <label :class="['form-label', classes]" for="mileage"
                >Kilometraje</label
              >
              <select
                :class="['form-control', classes]"
                id="mileage"
                v-model="schedule.car.mileage"
              >
                <option disabled>Selecciona un kilometraje</option>
                <option
                  v-for="mileage in mileages"
                  :value="mileage"
                  :key="mileage"
                  >{{ mileage }}</option
                >
              </select>
            </div>
            <span class="form-helper form-helper--error">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
        <div>
          <span class="form-helper mb-3">* Datos obligatorios</span>
        </div>
      </fieldset>
      <button class="button button--primary w-100" type="submit">
        <span class="button__text">{{ steps[currentStep].submit }}</span>
        <i v-if="currentStep !== 1" class="button__icon material-icons"
          >arrow_forward</i
        >
      </button>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { getBrandModels, getMileages } from '@/services/auth';
const dictionary = ['datos-personales', 'datos-del-vehiculo'];

export default {
  name: 'RegisterForm',
  data() {
    return {
      currentStep: 0,
      loading: false,
      models: [],
      mileages: [],
      brandId: null,
      schedule: {
        user: {
          rut: '',
          firstname: '',
          lastname: '',
          phone: '',
          email: '',
        },
        car: {
          brand: '',
          model: '',
          license: '',
          mileage: '',
        },
      },
      steps: [
        {
          label: '¡Queremos brindarte la mejor experiencia!',
          description:
            'Ingresa tus datos personales, así lograremos que nuestro servicio sea más personalizados según tus necesidades.',
          submit: 'Continuar',
        },
        {
          label: '¡Sólo faltan los datos de tu auto! ',
          description:
            'Ingresa tus datos personales, así lograremos que nuestro servicio sea más personalizados según tus necesidades.',
          submit: '¡Estás listo! Agenda una hora',
        },
      ],
    };
  },
  computed: {
    ...mapState(['current_brand']),
  },
  mounted() {
    this.brandId = process.env.VUE_APP_BRAND_ID;
    this.updateUrl();
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      if (this.currentStep === 1) {
        return this.submitForm();
      }

      this.currentStep++;

      this.updateUrl();

      this.handleGetModels();
      this.handleGetMileages();
    },
    updateUrl() {
      const { currentStep } = this;

      this.executeDataLayer();

      this.$router.push({
        name: 'register',
        params: { step: dictionary[currentStep] },
      });
    },
    executeDataLayer: async function() {
      if (!window.dataLayer) {
        return;
      }

      const eventData = {
        event: 'registro-paso',
        paso: this.currentStep + 1,
      };

      console.log('Sent to dataLayer', eventData);

      window.dataLayer.push(eventData);
    },
    submitForm() {
      this.loading = true;

      this.schedule.user.rut = this.schedule.user.rut.replace(/[.-]/g, '');
      this.schedule.user.phone = `+56${this.schedule.user.phone}`;

      this.$store
        .dispatch('registerUser', this.schedule)
        .then(() => this.$router.push({ name: 'schedule' }))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido registrar tu cuenta',
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    handleGetModelsByBrand() {
      this.handleGetModels(this.schedule.car.brand);
    },
    handleGetModels(brand) {
      if (this.current_brand.code === 'GA')
        brand = this.current_brand.children[0];

      this.getBrandModelsFromApi(
        (brand && brand.code) ||
          (this.current_brand && this.current_brand.code),
      )
        .then(models => (this.models = models))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener los modelos',
          });
        });
    },
    handleGetMileages() {
      this.getMileagesFromApi()
        .then(mileages => (this.mileages = mileages))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener los kilometrajes',
          });
        });
    },
    async getBrandModelsFromApi(code) {
      const response = await getBrandModels(code);
      return response.data.data;
    },
    async getMileagesFromApi(id) {
      const response = await getMileages(id);
      return response.data.data;
    },
  },
};
</script>

<style></style>
